import React from 'react';
import { I18nUtils } from '../../../../../../i18n/I18nUtils';
import { PsRoutes } from '../../../../routing/Routes';
import { MenuLeafNode } from './menus-by-role/menu-nodes/MenuLeafNode';
import { MenuParentNode } from './menus-by-role/menu-nodes/MenuParentNode';
import PropTypes from 'prop-types';

export const DocumentaryLibraryMenu = (
    {
        currentUser,
    },
) => {
    const canCreateDocument = currentUser.isAdmin();

    return (
        <MenuParentNode
            icon={'library_books'}
            label={I18nUtils.tr('TR_BIBLIOTECA_DOCUMENTAL')}
            activeRoutes={[
                PsRoutes.DOCUMENTARY_LIBRARY,
                PsRoutes.DOCUMENTARY_LIBRARY_ADD,
            ]}
        >
            {canCreateDocument &&
                <MenuLeafNode
                    label={I18nUtils.tr('TR_NUEVO_DOCUMENTO')}
                    route={PsRoutes.DOCUMENTARY_LIBRARY_ADD}
                    activeRoutes={[PsRoutes.DOCUMENTARY_LIBRARY_ADD]}
                />
            }
            <MenuLeafNode
                label={I18nUtils.tr('TR_TODOS_LOS_DOCUMENTOS')}
                route={PsRoutes.DOCUMENTARY_LIBRARY}
                activeRoutes={[PsRoutes.DOCUMENTARY_LIBRARY]}
            />
        </MenuParentNode>
    );
};

DocumentaryLibraryMenu.propTypes = {
    currentUser: PropTypes.object.isRequired,
};

DocumentaryLibraryMenu.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/menu/DocumentaryLibraryMenu.jsx